import _extends from "@babel/runtime/helpers/extends";

var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Tabs/Tabs.js",
    _this = this;

import React from 'react';
import styled from 'styled-components';
import TabBar from './src/TabBar';
import TabItem from './src/TabItem';
import withTabContext from './src/withTabContext';
import { noop } from '../../helpers';
import { useWindowSize } from '../../core/hooks/windowSize';
var TabItemWithContext = withTabContext(TabItem);
/**
 * Due to an iOS Safari bug, TabBar should have a defined max-width value
 * https://jira.dev.aws.singtel.com/browse/DLS-772
 */

var Wrapper = styled.div.withConfig({
  displayName: "Tabs__Wrapper",
  componentId: "sc-12gdgya-0"
})(["max-width:", "px;"], function (p) {
  return p.maxWidth;
});

var Tabs = function Tabs(_ref) {
  var tabs = _ref.tabs,
      selected = _ref.selected,
      onTabItemClick = _ref.onTabItemClick,
      secondary = _ref.secondary;
  var windowSize = useWindowSize();
  return /*#__PURE__*/React.createElement(Wrapper, {
    maxWidth: windowSize.width,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(TabBar, {
    selected: selected,
    secondary: secondary,
    onTabItemClick: onTabItemClick,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 7
    }
  }, tabs.map(function (tabProps, index) {
    return /*#__PURE__*/React.createElement(TabItemWithContext, _extends({}, tabProps, {
      key: index,
      tabItemWeight: tabs.length,
      secondary: secondary,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 31,
        columnNumber: 11
      }
    }));
  })));
};

Tabs.defaultProps = {
  onTabItemClick: noop,
  selected: null,
  tabs: []
};
export default Tabs;